import { GetCallRatingRequestPayload, GetCallRatingSuccessPayload, SetCallRatingRequestPayload, SetCallRatingSuccessPayload } from "../interfaces/callRating"
import { ErrorPayLoad } from "../interfaces/purchase"
import { Types } from "../types"
import { GetCallRatingError, GetCallRatingRequest, GetCallRatingReset, GetCallRatingSuccess, SetCallRatingError, SetCallRatingRequest, SetCallRatingSuccess } from "../types/callRating/actionType"


export const getCallRatingRequestAction = (payload: GetCallRatingRequestPayload): GetCallRatingRequest => ({
    type: Types.GET_CALL_RATING_REQUEST,
    payload
})

export const getCallRatingSuccessAction = (payload:GetCallRatingSuccessPayload): GetCallRatingSuccess => ({
    type: Types.GET_CALL_RATING_SUCCSEE,
    payload
})

export const getCallRatingErrorAction = (payload: ErrorPayLoad): GetCallRatingError => ({
    type: Types.GET_CALL_RATING_ERROR,
    payload
})
export const getCallRatingResetAction = () :GetCallRatingReset=> ({
    type: Types.GET_CALL_RATING_RESET,
    
})
//******************************************************************************************************** */
export const setCallRatingRequestAction = (payload: SetCallRatingRequestPayload): SetCallRatingRequest => ({
    type: Types.SET_CALL_RATING_REQUEST,
    payload
})

export const setCallRatingSuccessAction = (payload:SetCallRatingSuccessPayload): SetCallRatingSuccess => ({
    type: Types.SET_CALL_RATING_SUCCSEE,
    payload
})

export const setCallRatingErrorAction = (payload: ErrorPayLoad): SetCallRatingError => ({
    type: Types.SET_CALL_RATING_ERROR,
    payload
})
